'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BackgroundImage = require('../../../../../components/images/BackgroundImage');

var _BackgroundImage2 = _interopRequireDefault(_BackgroundImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconToolImage = function IconToolImage(_ref) {
    var imageSource = _ref.imageSource;
    return _react2.default.createElement(_BackgroundImage2.default, { className: 'IconToolImage', source: imageSource });
};

// Components
// Lib


IconToolImage.propTypes = {
    imageSource: _propTypes2.default.string.isRequired
};

exports.default = IconToolImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/IconToolImage.js
// module id = 2235
// module chunks = 0